export const apiPrefix = window.location.hostname === 'localhost' ? '' : '/api';

export const JOB_LABELS = {
    scraper_run: 'Scraper',
    digest_run: 'Digest',
    scheduled_search_run: 'Automatizirana pretraga',
    portal_health_report_sent: 'Health report',
    manual_trigger: 'Ručno pokretanje',
    briefing_job_run: 'Smart Brifing',
};

export const formatDate = (iso) => {
    if (!iso) return '—';
    try {
        return new Date(iso).toLocaleString('hr-HR', {
            day: '2-digit', month: '2-digit', year: 'numeric',
            hour: '2-digit', minute: '2-digit',
        });
    } catch {
        return iso;
    }
};

export const sortRows = (rows, key, dir, getValue) =>
    [...rows].sort((a, b) => {
        let av = getValue(a, key) ?? '';
        let bv = getValue(b, key) ?? '';
        if (typeof av === 'string') av = av.toLowerCase();
        if (typeof bv === 'string') bv = bv.toLowerCase();
        const cmp = av < bv ? -1 : av > bv ? 1 : 0;
        return dir === 'asc' ? cmp : -cmp;
    });

export const toggleDir = (prev, key) => ({
    key,
    dir: prev.key === key && prev.dir === 'asc' ? 'desc' : 'asc',
});

export const DISCOVERY_METHOD_COLORS = {
    rss: '#e8f5e9',
    html_selector: '#e3f2fd',
    html_legacy: '#fff3e0',
    feed: '#e8f5e9',
};

export const DISCOVERY_METHOD_LABELS = {
    rss: 'RSS',
    html_selector: 'HTML (selector)',
    html_legacy: 'HTML (legacy)',
    feed: 'Feed',
};

export const jobStatsSummary = (actionType, params) => {
    if (!params) return '—';
    switch (actionType) {
        case 'scraper_run':
            return `${params.portals_scraped ?? '?'} portala · ${params.articles_found ?? '?'} skeniranih · ${params.new_articles ?? '?'} novih · ${params.alerts_fired ?? '?'} alerta · ${params.elapsed_seconds ?? '?'}s`;
        case 'digest_run':
            return `${params.emails_sent ?? '?'} poslano · ${params.elapsed_seconds ?? '?'}s`;
        case 'scheduled_search_run':
            return `"${params.name ?? '?'}" — ${params.result_count ?? '?'} članaka · ${params.recipients ?? '?'} primatelja`;
        case 'portal_health_report_sent':
            return `${params.portals_total ?? '?'} portala · ${params.portals_zero_today ?? '?'} bez članaka`;
        case 'manual_trigger':
            return `Posao: ${params.job ?? '?'}`;
        case 'briefing_job_run':
            return `"${params.name ?? '?'}" — ${params.articles_found ?? '?'} članaka · ${params.clusters ?? '?'} klastera · ${params.recipients ?? '?'} primatelja`;
        default:
            return JSON.stringify(params);
    }
};

export const SectionHeader = ({ title }) => (
    <span style={{ display: 'block', marginTop: 32, marginBottom: 8, fontWeight: 600, color: '#2c3e50', borderBottom: '2px solid #0079bf', paddingBottom: 4, fontSize: '1.25rem' }}>
        {title}
    </span>
);
